import React from 'react';
import PropTypes from 'prop-types';
import ReactJWPlayer from 'react-jw-player';
import VideoPlayer from './jwPlayer';
import Vimeo from '@u-wave/react-vimeo';
import { connect } from 'react-redux';
import { FormatListNumbered } from '@material-ui/icons';

const displayName = 'ReactJWPlayerContainer';
const width = window.innerWidth
 
let intervalId;
class LiveJWPlayerContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoTitle: '',
      isPlayer: false,
      errorMessage: '',
      playlist: null,
      error: false
    };
 
  }

  componentDidMount(){
    
    // let channelId = this.props.channelId;
    
    // if (!channelId.match(/[a-zA-Z0-9]{8}/)) {
      
    //     this.setState({
    //       isPlayer: true,
    //         errorMessage: 'The provided channel id is not a valid Live Channel channel ID.'
    //     });
    //     // alert("");
    //     // throw new Error('Please modify the channel ID');
    // }
    // const VOD_CONFIG = {
    //     playlist: 'https://cdn.jwplayer.com/live/events/FBdtdAON.m3u8',
    //     // Repeat the VOD indefinitely while we wait for the livestream to become available.
    //     'repeat': true
    // };
    // this.setState({
    //     playlist: VOD_CONFIG
    // })
   
    // this.checkChannelStatus()
    
  }
    checkChannelStatus = () =>  {
      const channelId = this.props.channelId;
      const UPDATE_FREQUENCY = 10 * 1e3;
    console.log(`Checking channel Status: ID `,channelId);
    if (!intervalId) {
        // Make sure to execute this method every UPDATE_FREQUENCY milliseconds.
        intervalId = setInterval(this.checkChannelStatus, UPDATE_FREQUENCY);
    }
    
    this.getChannelStatus(channelId).then((channelStatus) => {
        console.log(channelStatus, "asljaslnd")
        if(channelStatus?.current_event === null) return this.setState({
          isPlayer: false,
          loading: false,
          errorMessage: 'offline, try again later'  
        }, () => setTimeout(() => {
          this.props.handleClose()
        }, 10000))
        // console.log("Received channel status: %O", channelStatus);
        if (channelStatus['status'] === 'active') {
          this.setState({
            isPlayer: true
          })
            // Determine the id of the active event based on the returned status.
            console.log(`Channel is Active`);
            console.log(channelStatus);
            const eventId = channelStatus['current_event'];
            if (eventId != null) {
                this.configurePlayer(eventId).catch((error) => {
                    console.log("Failed to start livestream playback: ${error}");
                });
                clearInterval(intervalId);
            } else {
                console.log("Channel active, but event id not yet set");
            }
        }
    }, (error) => {
      alert('Unable to fetch the channel status for ${channelId}: ${error}')
        this.setState({
          isPlayer: true,
            errorMessage: 'Unable to fetch the channel status for ${channelId}: ${error}'
        });
        clearInterval(intervalId);
    });
}


   fetchJSON = async (url) => {
    return await fetch(url)
        .then((response) => {
          //  alert(JSON.stringify(response))
            if (!response.ok) {
                throw new Error(`Unable to fetch ${url}: ${response.statusText}`);
            }
            return response.json();
        });
}
  configurePlayer = async (eventId) =>  {
  /** There may be a slight delay between the livestream becoming available, and its playlist to become available.
   * Therefore, we first attempt to fetch the playlist for the new live event, as soon as we have successfully fetched
   * a playlist, we will load it on the player and start playback of the livestream.
   */
  
  console.log(`Fetching livestream playlist with event id`, eventId);
  let playlist;
  let attempts = 0;
  while (!playlist) {
      try {
          playlist = await this.getPlaylist(eventId);
          this.setState({
            playlist,
            
          }, () => console.log(this.state))
      } catch (e) {
          ++attempts;
          console.error(e);
          if (attempts >= 5) {
              throw e;
          }
          /** Retry with exponential backoff, i.e. first retry after 5, 10, 20, 40, 80 seconds
           * after which we ultimately give up.
           */
          await this.sleep(2 ** (attempts - 1) * 5 * 1000);
      }
  }
 
   console.log(playlist);
  // Once a playlist is available, use it to configure the player.
  // playerInstance.setConfig({
  //     repeat: false,
  // });

  //  this.onReady(playlist)
  // playerInstance.load(playlist.playlist);
  // // Start playback
  // playerInstance.play();
  // console.log(`Playing livestream.`);
}


   getChannelStatus = (channelId) => {
    var url = `https://cdn.jwplayer.com/live/channels/${channelId}.json`;
    console.log(`Fetching `, url);
    return this.fetchJSON(url);
  }
   getPlaylist = (mediaId) => {
    return this.fetchJSON(`https://cdn.jwplayer.com/v2/media/${mediaId}`);
  }
  sleep = (ms) => {
    console.log(ms, "Asdasadasdasdsd")
    return new Promise(resolve => setTimeout(resolve, ms));
}

  onReady(event) {
    // interact with JW Player API here
    // const player = window.jwplayer('my-unique-id');
    // this.setState({
    //   playlist: event
    // })
  
  }
  componentWillUnmount(){
    clearInterval(intervalId);
  }
  onAdPlay(event) {
    // track the ad play here
  }
  onVideoLoad(event) {
    this.setState({
      videoTitle: event.item.description // this only works with json feeds!
    });
  }
  render() {
   
    return (
      <>
      <div className='react-jw-player-container'>
           {
              !this.state.isPlayer ?
              //     <ReactJWPlayer
              //     playerId='LeDK9Bar'
              //     playerScript='https://cdn.jwplayer.com/libraries/LeDK9Bar.js'
              //     playlist={this.state.playlist}
              //     onReady={this.onReady}
              //     isAutoPlay={true}
              // />
              <Vimeo
                video={`https://vimeo.com/event/${this.props.channelId}`}
                autoplay={true}
                  loop
                muted={false}
                showPortrait
                background={true}
                controls={true}
                style={{ marginLeft: width <= 780 ? 15 : 0}}
                width={width <= 780 ? 360 : 800}
                height={width <= 780 ? 300 : 600}
                onError={() => {
                  this.setState({
                    errorMessage: 'There is no live classes today',
                    error: true
                  })
                }}
             />
           :null
           }
            
        
      </div>
      {
                this.state.error &&
                <div style={{ width: '100%', height:'100%', alignSelf: 'center',  display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <h4>There is no live classes</h4>
                </div> 
             }
           
      </>
    );
  } 
}
 
const mapStatesToProps = state => ({
  sourceFileInfo: state.JwPlayerSourceInfo && state.JwPlayerSourceInfo.response && state.JwPlayerSourceInfo.response
})

export default connect(mapStatesToProps, {})(LiveJWPlayerContainer);